/**
 * Straight line path strategy (PRD-F5 §TR4).
 *
 * The only path strategy shipped in P5.5 — additional strategies (Bezier,
 * Orthogonal) are out-of-scope per PRD §Failure Conditions FC13.
 *
 * `id` matches `FALLBACK_STRATEGY_ID` so registering this strategy
 * automatically supplies the registry's forward-compat fallback for
 * persisted boards that reference unknown strategies.
 */

import {
  FALLBACK_STRATEGY_ID,
  type KonvaLineProps,
  type LinePathStrategy,
} from './line-path-strategy.interface.js';

export class StraightPathStrategy implements LinePathStrategy {
  readonly id: string = FALLBACK_STRATEGY_ID;

  // Straight ignores controlPoints — points are always [start, end].
  computePath(
    start: { x: number; y: number },
    end: { x: number; y: number },
    _controlPoints?: readonly { x: number; y: number }[],
  ): KonvaLineProps {
    return { points: [start.x, start.y, end.x, end.y] };
  }
}
